import { Controller } from "@hotwired/stimulus";

// Простой контроллер для dropdown меню
export default class extends Controller {
  static targets = ["menu"];

  connect() {
    // Закрывать dropdown при клике вне его
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
  }

  toggle(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle("hidden");

    if (!this.menuTarget.classList.contains("hidden")) {
      // Добавляем обработчик клика вне dropdown
      document.addEventListener("click", this.boundHandleClickOutside);
    } else {
      document.removeEventListener("click", this.boundHandleClickOutside);
    }
  }

  close() {
    this.menuTarget.classList.add("hidden");
    document.removeEventListener("click", this.boundHandleClickOutside);
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");
      document.removeEventListener("click", this.boundHandleClickOutside);
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside);
  }
}
